// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2-OBx","icon":"SortAdornment_icon__jPRHz","up":"SortAdornment_up__3g04p","down":"SortAdornment_down__8ufL0","active":"SortAdornment_active__3stXA"};